var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Dashboard } from "../constants/dashboard";
import { Status } from "../constants/status";
import employabilityScore from "../../assets/icons/tiles/emploability-score.svg";
import developmentAreas from "../../assets/icons/tiles/development-areas.svg";
import strengthsIcon from "../../assets/icons/tiles/strengths.svg";
import { ManageUser } from "../constants/manage_users";
var initialState = {
    status: Status.Loading,
};
function parseStats(data) {
    var strengths = [];
    var development = [];
    if (data.strengths && typeof data.strengths === 'object') {
        Object.keys(data.strengths).forEach(function (strengthKey) {
            if (data.strengths[strengthKey] === "strength") {
                if (strengthKey == "Require childcare") {
                    strengths.push("Does not Require Childcare");
                }
                else if (strengthKey == "Impact of Health") {
                    strengths.push("No Impact Of Health");
                }
                else {
                    strengths.push(strengthKey);
                }
            }
            else if (data.strengths[strengthKey] === "dev_areas" ||
                data.strengths[strengthKey] === "neither") {
                development.push(strengthKey);
            }
        });
    }
    var parsedData = [
        {
            score: data.employability_score || data["Average Final Score"],
            title: data.user_type === "jobseeker"
                ? "Your Score"
                : "Average Caseload Employability Score",
            linkTitle: "Based On Questionnaire",
            link: "/questionnaire",
            icon: employabilityScore,
            status: Status.Successful,
            userType: data.user_type,
        },
        {
            points: strengths,
            title: data.user_type === "jobseeker"
                ? "Your Strengths"
                : "Strengths",
            linkTitle: "View All",
            link: "/questionnaire/strengths",
            icon: strengthsIcon,
            status: Status.Successful,
            userType: data.user_type,
        },
        {
            points: development,
            title: "Your Development Areas",
            linkTitle: "Let's Get Started",
            link: "/questionnaire/development",
            icon: developmentAreas,
            status: Status.Successful,
            userType: data.user_type,
        },
    ];
    return parsedData;
}
var BarLabels = {
    "General Skills Score": "General Skill",
    "Job search confidence Score": ["Job Search", "Confidence"],
    "Personal attributes Score": ["Personal", "Attributes"],
    "Immediacy of employment Score": ["Immediacy", "of employment"],
    "Assets Score": "Assets",
    "Job-seeking behaviours Score": ["Job Seeking", "Behaviours"],
    "General skills": "General Skill",
    "Job search confidence": ["Job Search", "Confidence"],
    "Personal attributes": ["Personal", "Attributes"],
    "Perceived immediacy of employment": ["Immediacy", "of employment"],
    Assets: "Assets",
    "Job-seeking behaviours": ["Job Seeking", "Behaviours"],
    "General skills score": "General Skill",
    "Job search confidence score": ["Job Search", "Confidence"],
    "Personal attributes score": ["Personal", "Attributes"],
    "Immediacy of employment score": ["Immediacy", "of employment"],
    "Assets score": "Assets",
    "Job-seeking behaviours score": ["Job Seeking", "Behaviours"],
};
// simple graph data for non-jobseekers
function parseGraphData(data) {
    var parsedData = [];
    if (data.strengths_scores && typeof data.strengths_scores === 'object') {
        Object.keys(data.strengths_scores).forEach(function (value) {
            if (typeof data.strengths_scores[value] === "number") {
                var label = BarLabels[value];
                parsedData.push({
                    label: label,
                    score: data.strengths_scores[value],
                });
            }
        });
    }
    return parsedData;
}
// "Job-seeking behaviours" is the one domain that can come back as `null`
// (when the jobseeker isn't actively seeking employment, per
// strengths.py) rather than a number - unlike every other domain score.
// It should still always appear as a 0 bar rather than being dropped from
// the graph entirely.
var JOB_SEEKING_KEY = "Job-seeking behaviours score";
var JOB_SEEKING_LABEL = BarLabels[JOB_SEEKING_KEY];
function hasJobSeekingEntry(parsedData) {
    return parsedData.some(function (item) { return item.label === JOB_SEEKING_LABEL; });
}
function buildNonJobseekerGroupedData(payload) {
    var hasQ1Strengths = payload.strengths_scores_q1 && Object.keys(payload.strengths_scores_q1).length > 0;
    var hasQ2Strengths = payload.strengths_scores_q2 && Object.keys(payload.strengths_scores_q2).length > 0;
    var hasMilestoneStrengths = payload.strengths_scores_milestone && Object.keys(payload.strengths_scores_milestone).length > 0;
    if (!hasQ1Strengths && !hasQ2Strengths && !hasMilestoneStrengths) {
        return { graphData: parseGraphData(payload), groupedGraphData: undefined };
    }
    var combinedData = [];
    var domainLabels = {
        'General Skills': 'General Skill',
        'Job Search Confidence': ['Job Search', 'Confidence'],
        'Personal Attributes': ['Personal', 'Attributes'],
        'Perceived Immediacy': ['Immediacy', 'of employment'],
        'Assets': 'Assets',
        'Job Seeking Behaviours': ['Job Seeking', 'Behaviours']
    };
    var allDomains = new Set(__spreadArray(__spreadArray(__spreadArray([], Object.keys(payload.strengths_scores_q1 || {}), true), Object.keys(payload.strengths_scores_q2 || {}), true), Object.keys(payload.strengths_scores_milestone || {}), true));
    allDomains.forEach(function (domain) {
        var _a, _b, _c;
        var q1Score = ((_a = payload.strengths_scores_q1) === null || _a === void 0 ? void 0 : _a[domain]) || 0;
        var q2Score = ((_b = payload.strengths_scores_q2) === null || _b === void 0 ? void 0 : _b[domain]) || 0;
        if (hasMilestoneStrengths) {
            combinedData.push({
                label: domainLabels[domain] || domain,
                q1: q1Score,
                q2: ((_c = payload.strengths_scores_milestone) === null || _c === void 0 ? void 0 : _c[domain]) || 0,
                q3: q2Score,
                type: "strength_grouped_3"
            });
        }
        else {
            combinedData.push({
                label: domainLabels[domain] || domain,
                q1: q1Score,
                q2: q2Score,
                type: "strength_grouped"
            });
        }
    });
    var hasQ1Wellbeing = payload.wellbeing_score_q1 !== null && payload.wellbeing_score_q1 !== undefined;
    var hasQ2Wellbeing = payload.wellbeing_score_q2 !== null && payload.wellbeing_score_q2 !== undefined;
    var hasMilestoneWellbeing = payload.wellbeing_score_milestone !== null && payload.wellbeing_score_milestone !== undefined;
    if (hasQ1Wellbeing || hasQ2Wellbeing || hasMilestoneWellbeing) {
        if (hasMilestoneWellbeing) {
            combinedData.push({
                label: "Personal Wellbeing",
                q1: hasQ1Wellbeing ? payload.wellbeing_score_q1 : 0,
                q2: payload.wellbeing_score_milestone,
                q3: hasQ2Wellbeing ? payload.wellbeing_score_q2 : 0,
                type: "wellbeing_3"
            });
        }
        else {
            combinedData.push({
                label: "Personal Wellbeing",
                q1: hasQ1Wellbeing ? payload.wellbeing_score_q1 : 0,
                q2: hasQ2Wellbeing ? payload.wellbeing_score_q2 : 0,
                type: "wellbeing"
            });
        }
    }
    return {
        graphData: combinedData,
        groupedGraphData: createGroupedGraphData(combinedData),
    };
}
// grouped graph data for jobseekers
function parseGroupedGraphData(data) {
    var parsedData = [];
    var hasOldStrengths = data.strengths_scores_old && Object.keys(data.strengths_scores_old).length > 0;
    var hasMilestoneStrengths = data.strengths_scores_milestone && Object.keys(data.strengths_scores_milestone).length > 0;
    var hasNewStrengths = data.strengths_scores && Object.keys(data.strengths_scores).length > 0;
    if (hasOldStrengths && hasMilestoneStrengths && hasNewStrengths) {
        Object.keys(data.strengths_scores).forEach(function (value) {
            if (typeof data.strengths_scores[value] === "number") {
                var label = BarLabels[value];
                parsedData.push({
                    label: label,
                    q1: data.strengths_scores_old[value] || 0,
                    q2: data.strengths_scores_milestone[value] || 0,
                    q3: data.strengths_scores[value] || 0,
                    type: "employability_grouped_3"
                });
            }
        });
        if (!hasJobSeekingEntry(parsedData)) {
            parsedData.push({
                label: JOB_SEEKING_LABEL,
                q1: data.strengths_scores_old[JOB_SEEKING_KEY] || 0,
                q2: data.strengths_scores_milestone[JOB_SEEKING_KEY] || 0,
                q3: data.strengths_scores[JOB_SEEKING_KEY] || 0,
                type: "employability_grouped_3"
            });
        }
    }
    else if (hasOldStrengths && hasNewStrengths) {
        Object.keys(data.strengths_scores).forEach(function (value) {
            if (typeof data.strengths_scores[value] === "number") {
                var label = BarLabels[value];
                parsedData.push({
                    label: label,
                    q1: data.strengths_scores_old[value] || 0,
                    q2: data.strengths_scores[value] || 0,
                    type: "employability_grouped"
                });
            }
        });
        if (!hasJobSeekingEntry(parsedData)) {
            parsedData.push({
                label: JOB_SEEKING_LABEL,
                q1: data.strengths_scores_old[JOB_SEEKING_KEY] || 0,
                q2: data.strengths_scores[JOB_SEEKING_KEY] || 0,
                type: "employability_grouped"
            });
        }
    }
    else if (hasNewStrengths) {
        Object.keys(data.strengths_scores).forEach(function (value) {
            if (typeof data.strengths_scores[value] === "number") {
                var label = BarLabels[value];
                parsedData.push({
                    label: label,
                    score: data.strengths_scores[value],
                    type: "employability"
                });
            }
        });
        if (!hasJobSeekingEntry(parsedData)) {
            parsedData.push({
                label: JOB_SEEKING_LABEL,
                score: data.strengths_scores[JOB_SEEKING_KEY] || 0,
                type: "employability"
            });
        }
    }
    // Add wellbeing for jobseekers
    var hasQ1 = data.wellbeing_score_q1 !== null && data.wellbeing_score_q1 !== undefined;
    var hasMilestoneWellbeing = data.wellbeing_score_milestone !== null && data.wellbeing_score_milestone !== undefined;
    var hasQ2 = data.wellbeing_score_q2 !== null && data.wellbeing_score_q2 !== undefined;
    if (hasMilestoneWellbeing) {
        parsedData.push({
            label: "Personal Wellbeing",
            q1: hasQ1 ? data.wellbeing_score_q1 : 0,
            q2: data.wellbeing_score_milestone,
            q3: hasQ2 ? data.wellbeing_score_q2 : 0,
            type: "wellbeing_3"
        });
    }
    else if (hasQ1 || hasQ2) {
        parsedData.push({
            label: "Personal Wellbeing",
            q1: hasQ1 ? data.wellbeing_score_q1 : 0,
            q2: hasQ2 ? data.wellbeing_score_q2 : 0,
            type: "wellbeing"
        });
    }
    return parsedData;
}
function createGroupedGraphData(parsedData, secondLabel) {
    if (secondLabel === void 0) { secondLabel = 'Q2'; }
    var labels = [];
    var q1Scores = [];
    var q2Scores = [];
    var q3Scores = [];
    var hasQ2Data = false;
    var hasQ3Data = false;
    parsedData.forEach(function (item) {
        labels.push(item.label);
        // Handle both employability_grouped AND strength_grouped the same way
        if (item.type === "employability_grouped" || item.type === "strength_grouped") {
            var q1 = item.q1 || 0;
            var q2 = item.q2 || 0;
            if (q2 > 0)
                hasQ2Data = true;
            q1Scores.push([0.1, q1 > 0.1 ? q1 : 0.1]);
            q2Scores.push([0.1, q2 > 0.1 ? q2 : 0.1]);
            q3Scores.push([0.1, 0.1]);
        }
        else if (item.type === "employability_grouped_3" || item.type === "strength_grouped_3") {
            var q1 = item.q1 || 0;
            var q2 = item.q2 || 0;
            var q3 = item.q3 || 0;
            if (q2 > 0)
                hasQ2Data = true;
            if (q3 > 0)
                hasQ3Data = true;
            q1Scores.push([0.1, q1 > 0.1 ? q1 : 0.1]);
            q2Scores.push([0.1, q2 > 0.1 ? q2 : 0.1]);
            q3Scores.push([0.1, q3 > 0.1 ? q3 : 0.1]);
        }
        else if (item.type === "employability") {
            q1Scores.push([0.1, item.score > 0.1 ? item.score : 0.1]);
            q2Scores.push([0.1, 0.1]);
            q3Scores.push([0.1, 0.1]);
        }
        else if (item.type === "wellbeing") {
            var q1 = item.q1 || 0;
            var q2 = item.q2 || 0;
            if (q2 > 0)
                hasQ2Data = true;
            q1Scores.push([0.1, q1 > 0.1 ? q1 : 0.1]);
            q2Scores.push([0.1, q2 > 0.1 ? q2 : 0.1]);
            q3Scores.push([0.1, 0.1]);
        }
        else if (item.type === "wellbeing_3") {
            var q1 = item.q1 || 0;
            var q2 = item.q2 || 0;
            var q3 = item.q3 || 0;
            if (q2 > 0)
                hasQ2Data = true;
            if (q3 > 0)
                hasQ3Data = true;
            q1Scores.push([0.1, q1 > 0.1 ? q1 : 0.1]);
            q2Scores.push([0.1, q2 > 0.1 ? q2 : 0.1]);
            q3Scores.push([0.1, q3 > 0.1 ? q3 : 0.1]);
        }
    });
    var datasets = [
        {
            label: 'Q1',
            data: q1Scores,
            backgroundColor: function (context) {
                var ctx = context.chart.ctx;
                var x1 = 90 * Math.sin(5.88176);
                var y1 = 90 * Math.cos(5.88176);
                var gradient = ctx.createLinearGradient(x1, y1, 0, 0);
                gradient.addColorStop(0, "#6c63ff");
                gradient.addColorStop(1, "#9994FF");
                return gradient;
            },
            borderRadius: 200,
            borderSkipped: false,
            barPercentage: 0.8,
            categoryPercentage: 0.7,
        }
    ];
    if (hasQ2Data) {
        var secondDatasetLabel = hasQ3Data ? 'Milestone' : secondLabel;
        var secondDatasetIsMilestone_1 = secondDatasetLabel === 'Milestone';
        datasets.push({
            label: secondDatasetLabel,
            data: q2Scores,
            backgroundColor: function (context) {
                var ctx = context.chart.ctx;
                var x1 = 90 * Math.sin(5.88176);
                var y1 = 90 * Math.cos(5.88176);
                var gradient = ctx.createLinearGradient(x1, y1, 0, 0);
                if (secondDatasetIsMilestone_1) {
                    gradient.addColorStop(0, "#14B8A6");
                    gradient.addColorStop(1, "#99F6E4");
                }
                else {
                    gradient.addColorStop(0, "#FFB84D");
                    gradient.addColorStop(1, "#FFCF9F");
                }
                return gradient;
            },
            borderRadius: 200,
            borderSkipped: false,
            barPercentage: 0.8,
            categoryPercentage: 0.7,
        });
    }
    if (hasQ3Data) {
        datasets.push({
            // This is the final attempt (what's labeled "Questionnaire 2"
            // elsewhere in the UI) - it's the 3rd dataset only because the
            // milestone attempt physically sits before it.
            label: 'Q2',
            data: q3Scores,
            backgroundColor: function (context) {
                var ctx = context.chart.ctx;
                var x1 = 90 * Math.sin(5.88176);
                var y1 = 90 * Math.cos(5.88176);
                var gradient = ctx.createLinearGradient(x1, y1, 0, 0);
                gradient.addColorStop(0, "#FFB84D");
                gradient.addColorStop(1, "#FFCF9F");
                return gradient;
            },
            borderRadius: 200,
            borderSkipped: false,
            barPercentage: 0.8,
            categoryPercentage: 0.7,
        });
    }
    return {
        labels: labels,
        datasets: datasets,
    };
}
function parseUsername(data) {
    return data.username;
}
var parseEmpScore = function (data) {
    var parsedData = [];
    parsedData.push({
        label: ["Your Score", "Remaining Score"],
        score: data.employability_score || data["Average Final Score"],
    });
    var hasMilestone = data.milestone_employability_score !== null &&
        data.milestone_employability_score !== undefined;
    if (hasMilestone) {
        parsedData.pop();
        parsedData.push({
            label: "Questionnaire 1",
            score: data.old_employability_score,
        });
        parsedData.push({
            label: "Progression Milestone",
            score: data.milestone_employability_score,
        });
        parsedData.push({
            label: "Questionnaire 2",
            score: data.new_employability_score,
        });
    }
    else if (data.old_employability_score) {
        parsedData.pop();
        parsedData.push({
            label: "Questionnaire 1",
            score: data.old_employability_score,
        });
        parsedData.push({
            // The 2nd submission is the milestone attempt (not "Questionnaire 2")
            // until the final one has been done.
            label: data.second_attempt_is_milestone
                ? "Progression Milestone"
                : "Questionnaire 2",
            score: data.employability_score,
        });
    }
    return parsedData;
};
function parseObligations(data, key) {
    var obligations = [];
    if (data[key]) {
        Object.keys(data[key]).forEach(function (value) {
            obligations.push([value, data[key][value]]);
        });
    }
    return obligations;
}
var dashboardReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Dashboard.Update_Needs_Questionnaire:
            return __assign(__assign({}, state), { needs_questionnaire: action.payload, status: (state === null || state === void 0 ? void 0 : state.status) || Status.Successful });
        case Dashboard.Update_Terms_Accepted:
            return __assign(__assign({}, state), { logged_in_user_terms_accepted: action.payload, status: (state === null || state === void 0 ? void 0 : state.status) || Status.Successful });
        case Dashboard.Update_Privacy_Policy_Accepted:
            return __assign(__assign({}, state), { logged_in_user_privacy_policy_accepted: action.payload, status: (state === null || state === void 0 ? void 0 : state.status) || Status.Successful });
        case Dashboard.Stats_Tiles:
            return __assign(__assign({}, state), { status: Status.Loading });
        case Dashboard.Stats_Tiles_Successful:
            var isJobseeker = action.payload["user_type"] === "jobseeker";
            var graphData = void 0;
            var groupedGraphData = void 0;
            if (isJobseeker) {
                var parsedGroupedData = parseGroupedGraphData(action.payload);
                groupedGraphData = createGroupedGraphData(parsedGroupedData, action.payload.second_attempt_is_milestone ? 'Milestone' : 'Q2');
                graphData = parsedGroupedData;
            }
            else {
                // For non-jobseekers, create grouped data from Q1/Q2(/milestone) strength averages
                var nonJobseekerData = buildNonJobseekerGroupedData(action.payload);
                graphData = nonJobseekerData.graphData;
                groupedGraphData = nonJobseekerData.groupedGraphData;
            }
            return __assign(__assign({}, state), { user_type: action.payload["user_type"], stats: parseStats(action.payload), graphData: graphData, groupedGraphData: groupedGraphData, obligations: parseObligations(action.payload, "Client obligations data"), adviserObligations: parseObligations(action.payload, "Adviser obligations data"), adviser_clientObligations: parseObligations(action.payload, "Adviser client obligations data"), adviser_adviserObligations: parseObligations(action.payload, "Adviser adviser obligations data"), score: parseEmpScore(action.payload), username: parseUsername(action.payload), status: Status.Successful, yourDashboard: true, wellbeing_score_q1: action.payload.wellbeing_score_q1, wellbeing_score_q2: action.payload.wellbeing_score_q2, logged_in_user_terms_accepted: action.payload.logged_in_user_terms_accepted, logged_in_user_privacy_policy_accepted: action.payload.logged_in_user_privacy_policy_accepted });
        case Dashboard.Stats_Tiles_Error:
            return __assign(__assign({}, state), { status: Status.Error });
        case Dashboard.Ques_Attempt_Details:
            return __assign(__assign({}, state), { status: Status.Loading });
        case Dashboard.Ques_Attempt_Details_Successful:
            return __assign(__assign({}, state), { quesAttemptDetails: action.payload, status: Status.Successful });
        case Dashboard.Ques_Attempt_Details_Error:
            return __assign(__assign({}, state), { status: Status.Error });
        case Dashboard.Adviser_Info:
            return __assign(__assign({}, state), { status: Status.Loading });
        case Dashboard.Adviser_Info_Successful:
            return __assign(__assign({}, state), { adviserInfo: action.payload, status: Status.Successful });
        case Dashboard.Adviser_Info_Error:
            return __assign(__assign({}, state), { status: Status.Error });
        case ManageUser.ManageUserDashboard:
            return __assign(__assign({}, state), { status: Status.Loading });
        case ManageUser.ManageUserDashboard_Sucessful:
            var isViewingJobseeker = action.payload.user_type === "jobseeker";
            var manageGraphData = void 0;
            var manageGroupedGraphData = void 0;
            if (isViewingJobseeker) {
                var parsedGroupedData = parseGroupedGraphData(action.payload);
                manageGroupedGraphData = createGroupedGraphData(parsedGroupedData, action.payload.second_attempt_is_milestone ? 'Milestone' : 'Q2');
                manageGraphData = parsedGroupedData;
            }
            else {
                var nonJobseekerData = buildNonJobseekerGroupedData(action.payload);
                manageGraphData = nonJobseekerData.graphData;
                manageGroupedGraphData = nonJobseekerData.groupedGraphData;
            }
            return __assign(__assign({}, state), { stats: parseStats(action.payload), graphData: manageGraphData, groupedGraphData: manageGroupedGraphData, obligations: parseObligations(action.payload, "Client obligations data"), adviserObligations: parseObligations(action.payload, "Adviser obligations data"), adviser_clientObligations: parseObligations(action.payload, "Adviser client obligations data"), adviser_adviserObligations: parseObligations(action.payload, "Adviser adviser obligations data"), score: parseEmpScore(action.payload), viewing_username: parseUsername(action.payload), logged_in_username: action.payload.logged_in_username, logged_in_user_type: action.payload.logged_in_user_type, viewing_user_type: action.payload.user_type, status: Status.Successful, yourDashboard: action.payload.logged_in_username === parseUsername(action.payload), wellbeing_score_q1: action.payload.wellbeing_score_q1, wellbeing_score_q2: action.payload.wellbeing_score_q2, logged_in_user_terms_accepted: action.payload.logged_in_user_terms_accepted, logged_in_user_privacy_policy_accepted: action.payload.logged_in_user_privacy_policy_accepted });
        case Dashboard.Update_Ques_Attempt_Details:
            return __assign(__assign({}, state), { status: Status.Loading });
        case Dashboard.Update_Ques_Attempt_Details_Successful:
            return __assign(__assign({}, state), { quesAttemptDetails: action.payload, status: Status.Successful });
        case Dashboard.Update_Ques_Attempt_Details_Error:
            return __assign(__assign({}, state), { status: Status.Error });
        default:
            return state;
    }
};
export default dashboardReducer;
